import { createAnalyticsClient, gtm } from '@foundation-lib/analytics'

const analyticsClient = createAnalyticsClient({ providers: [gtm] })

export default analyticsClient
